import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';
import {
    EPaymentMethodActions,
    UpdatePaymentMethod,
    UpdatePaymentMethodFailure,
    UpdatePaymentMethodSuccess
} from '../actions/payment-method.actions';
import { CustomerService } from '../../services/customer.service';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { Store } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';
import { RibInterface } from '../../models/rib.interface';
import { AbstractEffects } from '../../../shared/abstract.effects';
import { GetCustomer } from '../actions/customer.actions';
import { SaveCustomerMission } from '../../../shared/store/actions/customer-mission.actions';

@Injectable()
export class PaymentMethodEffects extends AbstractEffects {

    rib: RibInterface = null;

    constructor(
        private actions: Actions,
        private customerService: CustomerService,
        public override store: Store<any>
    ) {
        super(store);
    }

    updatePaymentMethod = createEffect(() => this.actions.pipe(
      ofType<UpdatePaymentMethod>(EPaymentMethodActions.UpdatePaymentMethod),
      tap(params => { this.rib = params.payload; }),
      switchMap(() => this.customerService.updateRib(this.rib)),
      switchMap(() => of(new UpdatePaymentMethodSuccess())),
      tap( () => {
          let msg = this.rib.iban;
          if (this.rib.bic) {
              msg += ' - ' + this.rib.bic;
          }
          this.store.dispatch(
              new SaveCustomerMission(
                  {
                      step: 1,
                      routeValue: 'debit_pay_method',
                      message: 'RIB updated [' + msg + ']',
                  },
                  ConstsHelper.PROCEDURE_PAYMENT_METHOD_CHANGE,
                  'account'
              )
          );
      }),
      catchError((error: HttpErrorResponse) => {
          if (401 === error.status || 403 === error.status) {
              this.ResendRequestWithNewToken(new UpdatePaymentMethod(this.rib));
          } else {
              this.DisplayMessage('error_with_retry', 400, new UpdatePaymentMethodFailure());
              this.store.dispatch(new GetCustomer());
          }
          return throwError(error);
      })
  ));
}
